import {
  FETCH_DEDUCTIONS,
  FETCH_DEDUCTIONS_SUCCESS,
  FETCH_DEDUCTIONS_FAILURE,
  CREATE_DEDUCTION_REQUEST,
  CREATE_DEDUCTION_SUCCESS,
  CREATE_DEDUCTION_FAILURE,
  DELETE_DEDUCTION,
  DELETE_DEDUCTION_SUCCESS,
  DELETE_DEDUCTION_FAILURE,
  CHANGE_DEDUCTION_STATUS,
  CHANGE_DEDUCTION_STATUS_SUCCESS,
  CHANGE_DEDUCTION_STATUS_FAILURE
} from "./actionTypes";

// Fetch Deductions
export const fetchDeductions = (unitId) => ({
  type: FETCH_DEDUCTIONS,
  payload: { unitId }
});

export const fetchDeductionsSuccess = (roles) => ({
  type: FETCH_DEDUCTIONS_SUCCESS,
  payload: roles,
});

export const fetchDeductionsFailure = (error) => ({
  type: FETCH_DEDUCTIONS_FAILURE,
  payload: error,
});


// Create Deduction
export const createDeductionRequest = (formData, isEdit) => ({
  type: CREATE_DEDUCTION_REQUEST,
  payload: { formData, isEdit },
});

export const createDeductionSuccess = (response) => ({
  type: CREATE_DEDUCTION_SUCCESS,
  payload: response,
});

export const createDeductionFailure = (error) => ({
  type: CREATE_DEDUCTION_FAILURE,
  payload: error,
});

export const changeDeductionStatus = (payload) => ({
  type: CHANGE_DEDUCTION_STATUS,
  payload,
});

export const changeDeductionStatusSuccess = (response) => ({
  type: CHANGE_DEDUCTION_STATUS_SUCCESS,
  payload: response,
});

export const changeDeductionStatusFailure = (error) => ({
  type: CHANGE_DEDUCTION_STATUS_FAILURE,
  payload: error,
});

// Delete Deduction
export const deleteDeduction = (formdata) => ({
  type: DELETE_DEDUCTION,
  payload: formdata,
});

export const deleteDeductionSuccess = (response) => ({
  type: DELETE_DEDUCTION_SUCCESS,
  payload: response,
});

export const deleteDeductionFailure = (error) => ({
  type: DELETE_DEDUCTION_FAILURE,
  payload: error,
});